import {
  JaBack,
  JaCalf,
  JaElbow,
  JaFallPrevention,
  JaFoot,
  JaHand,
  JaHip,
  JaKnee,
  JaNeck,
  JaOsteoporosis,
  JaShoulder,
  JaWrist,
} from "assets";

export const JointImage = ({ id }: { id: string }) => {
  switch (id) {
    case "lower_leg":
    case "achilles_tendinopathy": {
      return <JaCalf />;
    }
    case "wrist":
    case "wrist_pain": {
      return <JaWrist />;
    }
    case "foot":
    case "plantar_faschiit":
    case "hallux_valgus":
    case "foot_oa_or_unspecified":
    case "ankle_instability": {
      return <JaFoot />;
    }
    case "back":
    case "low_back_pain": {
      return <JaBack />;
    }
    case "hand":
    case "hand_oa": {
      return <JaHand />;
    }
    case "neck": {
      return <JaNeck />;
    }
    case "shoulder":
    case "shoulder_pain": {
      return <JaShoulder />;
    }
    case "hip":
    case "trochanterit":
    case "hip_pain_unspecific":
    case "post_op_hip":
    case "pre_op_hip":
    case "hip_and_knee_oa":
    case "hip_oa": {
      return <JaHip />;
    }
    case "knee":
    case "patellofemoral_pain_syndrome":
    case "knee_instability":
    case "post_op_knee":
    case "pre_op_knee":
    case "knee_oa": {
      return <JaKnee />;
    }
    case "elbow":
    case "general_elbow_pain":
    case "lateral_epicondylalgia":
    case "medial_epicondylalgia": {
      return <JaElbow />;
    }
    case "osteoporosis": {
      return <JaOsteoporosis />;
    }
    case "fall_prevention": {
      return <JaFallPrevention />;
    }
    default: {
      return <></>;
    }
  }
};
